module.exports = __webpack_public_path__ + "images/start-point-icon.fc8a8768ae6e159eabd72e424208a6c0.png";